// GK Prepaid Quiz — 4-Week Prepaid plan pages only.
// Loaded by snippets/gk-quiz-modal.liquid INSTEAD of homepage-quiz.js when the
// current product is one of the 4-week prepaid plans.
//
// Why this file exists: homepage-quiz.js is hard-coded to the WEEKLY subscription
// products, so on a prepaid page it walked the customer through a quiz and then
// added a weekly plan to the cart. This version stays on the prepaid products.
//
// The flow deliberately mirrors homepage-quiz.js — same steps, same look, same
// per-meal price bar — with two differences forced by the product data:
//   * no "first time with Green Kitchen?" step (removed at Max's request)
//   * no "how many days" step and no breakfast toggle — prepaid only exists as
//     5-Day Plan / Lunch and Dinner | Lunch | Dinner, so there is nothing to sell.
(function () {
  var WEEKS = 4;
  var DAYS_PER_WEEK = 5;
  var MAX_PICK = 3;

  // diet -> the prepaid product, plus the weekly product used only to work out
  // how much the customer saves against the standard weekly price.
  var DIET = {
    'Balanced':    { prepaid: 'healthy-balanced-meal-plan-4-week-plan-nutritious-food',    weekly: 'balanced-meal-plan-high-protein-wholesome-nutritious-food' },
    'Pescatarian': { prepaid: 'pescatarian-meal-plan-healthy-4-week-plan-home-delivery',   weekly: 'pescatarian-meal-plan-high-quality-balanced-nutrition' },
    'Vegetarian':  { prepaid: 'vegetarian-meal-plan-prepaid-4-week-plan-monday-to-friday', weekly: 'vegetarian-meal-plan-fresh-balanced-delicious-healthy-meals' },
    'Vegan':       { prepaid: 'vegan-meal-plan-prepaid-4-week-plan-monday-to-friday',      weekly: 'vegan-meal-plan-nutrient-dense-fresh-food-delivery' }
  };
  // prepaid handle -> diet, so the quiz opens on the diet whose page you're on
  var HANDLE_TO_DIET = {};
  Object.keys(DIET).forEach(function (d) { HANDLE_TO_DIET[DIET[d].prepaid] = d; });

  var DIET_RESTRICTIONS = {
    'Balanced':    { allergies: ['Tree Nuts', 'Peanuts', 'Sesame', 'Gluten', 'Eggs', 'Dairy', 'Shellfish'], intolerances: ['Beef', 'Fish', 'Lamb', 'Chicken', 'Duck', 'Salmon', 'Tuna'] },
    'Pescatarian': { allergies: ['Tree Nuts', 'Peanuts', 'Sesame', 'Gluten', 'Eggs', 'Dairy', 'Shellfish'], intolerances: ['Smoked Fish', 'Raw Fish', 'Impossible Meat', 'Tuna', 'Salmon'] },
    'Vegan':       { allergies: ['Tree Nuts', 'Peanuts', 'Sesame', 'Gluten'], intolerances: ['Tofu', 'Tempeh', 'Impossible Meat'] },
    'Vegetarian':  { allergies: ['Tree Nuts', 'Peanuts', 'Sesame', 'Gluten', 'Eggs', 'Dairy'], intolerances: ['Tofu', 'Tempeh', 'Impossible Meat'] }
  };

  var DIET_IMG = {
    'Balanced':    'https://cdn.shopify.com/s/files/1/0589/3662/3268/files/Balanced-Meal-Plan-Fresh-and-Protein-Packed-Green-Kitchen.webp?v=1741163182',
    'Pescatarian': 'https://cdn.shopify.com/s/files/1/0589/3662/3268/files/Pescatarian-Meal-Plan-Fresh-and-Nutritious-Green-Kitchen.webp?v=1741164619',
    'Vegetarian':  'https://cdn.shopify.com/s/files/1/0589/3662/3268/products/Vegetarian-Meal-Plan-Balanced-and-Delicious-Green-Kitchen.webp?v=1741166906',
    'Vegan':       'https://cdn.shopify.com/s/files/1/0589/3662/3268/products/Vegan-Meal-Plan-Fresh-and-Nutrient-Rich-Diet-Green-Kitchen.webp?v=1741166089'
  };

  var CSS = '#gkQuizRoot{--green:#16432f;--lime:#C2ED47;--lime-d:#aede2f;--cream:#f6f4ec;--ink:#1f231f;--muted:#5f655c;--line:#e3e6dd;--amber:#e9a23b;--sans:"DM Sans",system-ui,sans-serif;--serif:"DM Serif Display",Georgia,serif;}'
    + '#gkQuizRoot *{box-sizing:border-box}'
    + '#gkQuizRoot .gkq-wrap{max-width:620px;margin:0 auto;padding:18px 16px 36px;font-family:var(--sans);color:var(--ink)}'
    + '#gkQuizRoot .card{background:#fff;border:1px solid var(--line);border-radius:20px;padding:26px;box-shadow:0 12px 40px rgba(0,0,0,.06)}'
    + '#gkQuizRoot .top{background:var(--green);margin:-26px -26px 0;padding:20px 26px;border-radius:20px 20px 0 0;color:var(--cream)}'
    + '#gkQuizRoot .gkq-trust{font-size:12.5px;color:var(--muted);text-align:center;padding:11px 4px;border-bottom:1px solid var(--line);margin:0 -26px 20px}'
    + '#gkQuizRoot .gkq-trust b{color:var(--ink)}'
    + '#gkQuizRoot .gkq-trust .stars{color:var(--amber);letter-spacing:1px}'
    + '#gkQuizRoot .gkq-menu{text-align:center;margin-top:16px}'
    + '#gkQuizRoot .gkq-menu a{color:var(--green);font-weight:600;font-size:13px;text-decoration:underline;cursor:pointer}'
    + '#gkQuizRoot .bar{height:5px;background:rgba(255,255,255,.2);border-radius:99px;overflow:hidden;margin-bottom:12px}'
    + '#gkQuizRoot .bar i{display:block;height:100%;background:var(--lime);width:16%;transition:width .3s}'
    + '#gkQuizRoot .step-no{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:rgba(246,244,236,.7);font-weight:700}'
    + '#gkQuizRoot .card h1{font-family:var(--serif);font-weight:400;font-size:24px;margin:5px 0 0;color:var(--cream)}'
    + '#gkQuizRoot .plan-chip{display:inline-block;background:var(--lime);color:var(--green);font-weight:700;font-size:11px;letter-spacing:.06em;text-transform:uppercase;padding:4px 10px;border-radius:99px;margin-bottom:8px}'
    + '#gkQuizRoot .opt{display:flex;align-items:center;gap:14px;border:1.5px solid var(--line);border-radius:14px;padding:12px 14px;margin:10px 0;cursor:pointer;transition:.15s;background:#fff}'
    + '#gkQuizRoot .opt:hover{border-color:#bcd3c4}'
    + '#gkQuizRoot .opt.sel{border-color:var(--green);box-shadow:0 0 0 3px rgba(22,67,47,.12);background:#f4f8f4}'
    + '#gkQuizRoot .opt .em{font-size:24px;width:30px;text-align:center}'
    + '#gkQuizRoot .opt .thumb{width:48px;height:48px;border-radius:10px;overflow:hidden;flex:none}'
    + '#gkQuizRoot .opt .thumb img{width:100%;height:100%;object-fit:cover;display:block}'
    + '#gkQuizRoot .opt b{font-size:16px}'
    + '#gkQuizRoot .opt small{display:block;color:var(--muted);font-size:13px}'
    + '#gkQuizRoot .opt .chk{margin-left:auto;width:22px;height:22px;border-radius:50%;border:2px solid var(--line);flex:none}'
    + '#gkQuizRoot .opt.sel .chk{border-color:var(--green);background:var(--green) radial-gradient(circle,#fff 30%,transparent 32%)}'
    + '#gkQuizRoot .nav{display:flex;justify-content:space-between;align-items:center;margin-top:22px;gap:12px}'
    + '#gkQuizRoot .back{background:#fff;border:1.5px solid var(--line);color:var(--ink);font-family:var(--sans);font-weight:700;font-size:15px;padding:13px 26px;border-radius:99px;cursor:pointer;transition:.15s}'
    + '#gkQuizRoot .back:hover{border-color:#bcd3c4}'
    + '#gkQuizRoot .btn{background:var(--lime);color:var(--green);border:0;border-radius:99px;font-family:var(--sans);font-weight:700;font-size:16px;padding:14px 30px;cursor:pointer;transition:.15s}'
    + '#gkQuizRoot .btn:hover{background:var(--lime-d)}'
    + '#gkQuizRoot .btn:disabled{opacity:.4;cursor:not-allowed}'
    + '#gkQuizRoot .allerg{display:flex;flex-wrap:wrap;gap:9px;margin-top:6px}'
    + '#gkQuizRoot .tag{border:1.5px solid var(--line);border-radius:99px;padding:9px 15px;font-size:14px;cursor:pointer;background:#fff;transition:.15s}'
    + '#gkQuizRoot .tag.sel{border-color:var(--green);background:var(--green);color:#fff}'
    + '#gkQuizRoot .sum-row{display:flex;justify-content:space-between;gap:14px;padding:9px 0;border-bottom:1px solid var(--line);font-size:15px}'
    + '#gkQuizRoot .sum-row b{font-weight:700;text-align:right}'
    + '#gkQuizRoot .muted{color:var(--muted)}'
    + '#gkQuizRoot .pill{display:inline-block;background:#eef6e9;color:var(--green);font-weight:700;font-size:12px;padding:4px 11px;border-radius:99px;margin-top:8px}'
    + '#gkQuizRoot .savebar{background:var(--lime);color:var(--green);font-weight:700;font-size:13.5px;text-align:center;padding:10px 14px;border-radius:12px;margin-top:10px}'
    + '@media(max-width:480px){#gkQuizRoot .gkq-wrap{padding:12px 10px 26px}#gkQuizRoot .card{padding:18px}#gkQuizRoot .top{margin:-18px -18px 0;padding:16px 18px}#gkQuizRoot .gkq-trust{margin:0 -18px 16px}#gkQuizRoot .card h1{font-size:22px}#gkQuizRoot .sum-row{padding:7px 0;font-size:14px}}';

  var MARKUP = '<div class="gkq-wrap">'
    + '<div class="card">'
    + '<div class="top"><div class="bar"><i id="gkBar"></i></div><div class="step-no" id="gkStepNo"></div><div class="plan-chip" id="gkChip"></div><h1 id="gkTitle"></h1></div>'
    + '<div class="gkq-trust" id="gkTrust"><span class="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> <b>4.8</b> &middot; <b>10,000+</b> happy customers &middot; Free nutrition consult</div>'
    + '<div id="gkBody"></div>'
    + '<div class="nav"><button class="back" id="gkBack" style="visibility:hidden">&larr; Back</button><button class="btn" id="gkNext" style="display:none">Continue &rarr;</button></div>'
    + '</div>'
    + '<div class="gkq-menu"><a id="gkMenuLink" target="_blank" rel="noopener">This week’s menu &rarr;</a></div>'
    + '</div>';

  var styled = false;
  function injectStyle() {
    if (styled) return;
    styled = true;
    var f = document.createElement('link');
    f.rel = 'stylesheet';
    f.href = 'https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@400;500;600;700&display=swap';
    document.head.appendChild(f);
    var st = document.createElement('style');
    st.id = 'gkPrepaidQuizStyle';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function ensureOverlay() {
    var ov = document.getElementById('gkQuizOverlay');
    if (ov) return ov;
    ov = document.createElement('div');
    ov.id = 'gkQuizOverlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.style.cssText = 'position:fixed;inset:0;z-index:99999;display:none;justify-content:center;align-items:flex-start;padding:14px;background:rgba(10,20,15,.62);overflow:auto';
    ov.innerHTML = '<div id="gkQuizModal" style="position:relative;width:100%;max-width:680px;margin:auto;background:#f6f4ec;border-radius:20px;box-shadow:0 20px 70px rgba(0,0,0,.35)"><button id="gkQuizClose" aria-label="Close" style="position:absolute;top:8px;right:10px;z-index:5;width:34px;height:34px;border:0;border-radius:50%;background:#fff;color:#16432f;font-size:16px;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.2)">&#10005;</button><div id="gkQuizRoot"></div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeQuiz(); });
    document.getElementById('gkQuizClose').addEventListener('click', closeQuiz);
    return ov;
  }

  function closeQuiz() {
    var ov = document.getElementById('gkQuizOverlay');
    if (ov) ov.style.display = 'none';
    document.body.style.overflow = '';
  }
  window.closeQuiz = closeQuiz;
  window.handleOverlayClick = function () {};
  window.filterMeals = function () {};
  window.choosePlan = function (d) { window.openQuiz(d); };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuiz(); });

  window.openQuiz = function (presetDiet) {
    var handle = window.GK_CURRENT_PRODUCT || '';
    if (!HANDLE_TO_DIET[handle]) return; // not a prepaid page — nothing to do
    injectStyle();
    var ov = ensureOverlay();
    document.getElementById('gkQuizRoot').innerHTML = MARKUP;
    ov.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    if (ov.scrollTo) ov.scrollTo(0, 0);
    var pmap = { balanced: 'Balanced', pescatarian: 'Pescatarian', vegan: 'Vegan', vegetarian: 'Vegetarian' };
    var preset = (typeof presetDiet === 'string' && pmap[presetDiet]) ? pmap[presetDiet] : HANDLE_TO_DIET[handle];
    startQuiz(preset);
  };

  function startQuiz(presetDiet) {
    var ans = {
      diet: presetDiet || null,
      size: null,
      mealParts: { lunch: true, dinner: true },
      meals: null,
      hasAllergies: null,
      allergies: [],
      intolerances: [],
      deliveryTime: null
    };
    var step = 0;

    var STEPS = [
      { key: 'diet', title: 'What’s your dietary preference?', type: 'single', opts: [
        { v: 'Balanced',    img: DIET_IMG['Balanced'],    sub: 'Meat, fish & poultry' },
        { v: 'Pescatarian', img: DIET_IMG['Pescatarian'], sub: 'Seafood & plants' },
        { v: 'Vegetarian',  img: DIET_IMG['Vegetarian'],  sub: 'Eggs, dairy & plants' },
        { v: 'Vegan',       img: DIET_IMG['Vegan'],       sub: '100% plant-based' } ] },
      { key: 'size', title: 'What portion size suits you?', type: 'single', opts: [
        { v: 'Low Carb', sub: '350–450 cal · weight-loss' },
        { v: 'Standard', sub: '500–600 cal · balanced' },
        { v: 'Large',    sub: '700–800 cal · active' } ] },
      { key: 'allergy', title: 'Any allergies or intolerances?', type: 'allergy', opts: [
        { v: 'No',  sub: 'None for me' },
        { v: 'Yes', sub: 'Yes — let me choose' } ] },
      { key: 'meals', title: 'Choose your meals', type: 'meals', opts: [] },
      { key: 'deliveryTime', title: 'When should we deliver?', type: 'delivery', opts: [] }
    ];

    var root = document.getElementById('gkQuizRoot');
    var bodyEl = root.querySelector('#gkBody'),
        nextBtn = root.querySelector('#gkNext'),
        backBtn = root.querySelector('#gkBack'),
        barEl = root.querySelector('#gkBar'),
        titleEl = root.querySelector('#gkTitle'),
        stepNoEl = root.querySelector('#gkStepNo'),
        chipEl = root.querySelector('#gkChip'),
        gkTrust = root.querySelector('#gkTrust');

    (function () {
      var url = '/pages/week-fig';
      try {
        var links = [].slice.call(document.querySelectorAll('nav a, .nav-links a, .nav-drawer-links a'));
        var m = links.filter(function (a) { return /this week.?s menu/i.test((a.textContent || '')); })[0];
        if (m && m.getAttribute('href')) url = m.getAttribute('href');
      } catch (e) {}
      var ml = root.querySelector('#gkMenuLink');
      if (ml) ml.href = url;
    })();

    // ── product data ─────────────────────────────────────────
    var CACHE = {}, LOADING = {};
    function load(handle) {
      if (!handle || CACHE[handle] || LOADING[handle]) return;
      LOADING[handle] = true;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { CACHE[handle] = p; LOADING[handle] = false; render(); })
        .catch(function () { LOADING[handle] = false; });
    }
    function loadDiet(diet) {
      var d = DIET[diet];
      if (!d) return;
      load(d.prepaid);
      load(d.weekly);
    }

    function optsOf(v) {
      if (v.options && v.options.length) return v.options;
      return String(v.name || '').split(' - ').pop().split(' / ');
    }
    function findVariant(product, meals, size, requireFiveDay) {
      if (!product || !meals || !size) return null;
      var wm = meals.toLowerCase(), ws = size.toLowerCase();
      return product.variants.filter(function (v) {
        var o = optsOf(v).map(function (x) { return String(x).trim().toLowerCase(); });
        if (o.length < 3) return false;
        if (requireFiveDay && o[0].indexOf('5-day plan') !== 0) return false;
        return o[1] === wm && o[2].indexOf(ws) === 0;
      })[0] || null;
    }
    function mealLabel(m) {
      if (m.lunch && m.dinner) return 'Lunch and Dinner';
      if (m.lunch) return 'Lunch';
      if (m.dinner) return 'Dinner';
      return null;
    }
    function mealsPerDay(meals) { return meals === 'Lunch and Dinner' ? 2 : 1; }
    function mealCount(meals) { return WEEKS * DAYS_PER_WEEK * mealsPerDay(meals); }

    // Everything the price bar and summary need, from the live product data.
    function quote(meals, size) {
      var d = DIET[ans.diet];
      if (!d || !meals || !size) return null;
      var v = findVariant(CACHE[d.prepaid], meals, size, false);
      if (!v) return null;
      var alloc = (v.selling_plan_allocations || [])[0];
      var total = (alloc && alloc.price != null) ? alloc.price / 100 : v.price / 100;
      var count = mealCount(meals);
      var q = {
        variant: v,
        sellingPlan: alloc ? alloc.selling_plan_id : null,
        total: total,
        meals: count,
        perMeal: count ? total / count : null
      };
      var w = findVariant(CACHE[d.weekly], meals, size, true);
      if (w) {
        var weeklyTotal = (w.price / 100) * WEEKS;
        if (weeklyTotal > total) {
          q.weeklyTotal = weeklyTotal;
          q.save = weeklyTotal - total;
          q.savePct = Math.round((q.save / weeklyTotal) * 100);
        }
      }
      return q;
    }
    function money(n) { return '$' + n.toFixed(2); }

    // Same green per-meal bar the weekly quiz shows.
    function priceBar() {
      var q = quote(ans.meals || mealLabel(ans.mealParts), ans.size);
      if (!q || q.perMeal == null) return '';
      return '<div style="background:var(--green);color:var(--cream);border-radius:14px;padding:16px 18px;margin:18px 0 2px;text-align:center">'
        + '<span style="font-family:var(--serif);font-size:27px;color:var(--lime)">' + money(q.perMeal) + '</span>'
        + '<span style="font-size:14px;color:rgba(246,244,236,.85)"> / meal</span></div>';
    }

    // ── delivery date helpers (same rules as the weekly quiz) ──
    function deliveryInfo(choice) {
      var now = new Date();
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var daysToSun = (7 - d.getDay()) % 7;
      var sun = new Date(d); sun.setDate(d.getDate() + daysToSun);
      var cutoff = new Date(sun); cutoff.setDate(sun.getDate() - 2); cutoff.setHours(23, 59, 59, 999);
      if (now > cutoff) { sun.setDate(sun.getDate() + 7); }
      var isMon = (choice === 'AM');
      var deliv = new Date(sun);
      if (isMon) deliv.setDate(sun.getDate() + 1);
      return {
        date: deliv.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
        dateShort: deliv.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        day: isMon ? 'Monday' : 'Sunday',
        time: isMon ? '8:00 AM - 12:00 PM' : '7:00 PM - 10:00 PM'
      };
    }
    function joinDays(a) { return a.length < 3 ? a.join(' & ') : a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1]; }

    function render() {
      if (step >= STEPS.length) return renderSummary();
      var s = STEPS[step];
      if (ans.diet) loadDiet(ans.diet);
      chipEl.textContent = (ans.diet ? ans.diet + ' · ' : '') + '4-week prepaid';
      if (gkTrust) gkTrust.style.display = (step >= 2) ? 'none' : '';
      titleEl.textContent = s.title;
      stepNoEl.textContent = 'Step ' + (step + 1) + ' of ' + STEPS.length;
      barEl.style.width = Math.round((step / STEPS.length) * 100 + 8) + '%';
      backBtn.style.visibility = step === 0 ? 'hidden' : 'visible';

      var html = '', showNext = false, nextDisabled = false;

      if (s.type === 'meals') {
        var m = ans.mealParts;
        [['lunch', 'Lunch'], ['dinner', 'Dinner']].forEach(function (x) {
          html += '<div class="opt' + (m[x[0]] ? ' sel' : '') + '" data-m="' + x[0] + '"><div><b>' + x[1] + '</b></div><span class="chk"></span></div>';
        });
        html += '<div class="muted" style="font-size:13px;margin:18px 0 6px"><span style="color:var(--green)">More meals = lower price per meal.</span></div>';
        if (!mealLabel(m)) html += '<div class="muted" style="font-size:12px;margin-top:10px;color:#b04a2a">Pick at least Lunch or Dinner.</div>';
        html += priceBar();
        showNext = true;
        nextDisabled = !mealLabel(m);
      } else if (s.type === 'delivery') {
        var pm = ['Sun', 'Tue', 'Thu'], am = ['Mon', 'Wed', 'Fri'];
        var pmI = deliveryInfo('PM'), amI = deliveryInfo('AM');
        html += '<div class="muted" style="font-size:14px;margin-bottom:4px;line-height:1.5">Your 5-day plan is delivered <b style="color:var(--ink)">3 times a week</b> for 4 weeks · free island-wide.</div>';
        html += '<div style="font-weight:700;font-size:15px;margin:12px 0 8px">Choose your window</div>';
        html += '<div class="opt' + (ans.deliveryTime === 'PM' ? ' sel' : '') + '" data-v="PM"><span class="em">🌙</span><div><b>Evenings · 7–10 PM</b><small>Starts ' + pmI.day.slice(0, 3) + ', ' + pmI.dateShort + '</small><small>then ' + joinDays(pm.slice(1)) + '</small></div><span class="chk"></span></div>';
        html += '<div class="opt' + (ans.deliveryTime === 'AM' ? ' sel' : '') + '" data-v="AM"><span class="em">🌅</span><div><b>Mornings · 8 AM–12 PM</b><small>Starts ' + amI.day.slice(0, 3) + ', ' + amI.dateShort + '</small><small>then ' + joinDays(am.slice(1)) + '</small></div><span class="chk"></span></div>';
        html += priceBar();
      } else if (s.type === 'allergy') {
        s.opts.forEach(function (o) {
          var selected = ans.hasAllergies === (o.v === 'Yes');
          html += '<div class="opt' + (selected ? ' sel' : '') + '" data-v="' + o.v + '"><div><b>' + o.v + '</b><small>' + o.sub + '</small></div><span class="chk"></span></div>';
        });
        if (ans.hasAllergies === true) {
          var R = DIET_RESTRICTIONS[ans.diet] || { allergies: [], intolerances: [] };
          html += '<div style="margin-top:6px"><div class="muted" style="font-size:13px;margin:12px 0 5px">Allergies — tap any to leave out:</div><div class="allerg">';
          R.allergies.forEach(function (a) { html += '<span class="tag' + (ans.allergies.indexOf(a) > -1 ? ' sel' : '') + '" data-g="a" data-a="' + a + '">' + a + '</span>'; });
          html += '</div><div class="muted" style="font-size:13px;margin:18px 0 5px">Intolerances — tap any to leave out:</div><div class="allerg">';
          R.intolerances.forEach(function (a) { html += '<span class="tag' + (ans.intolerances.indexOf(a) > -1 ? ' sel' : '') + '" data-g="i" data-a="' + a + '">' + a + '</span>'; });
          html += '</div><div class="muted" style="font-size:12px;margin-top:10px">Pick up to ' + MAX_PICK + ' in each list.</div></div>';
          showNext = true;
        }
      } else {
        s.opts.forEach(function (o) {
          var icon = o.img ? '<span class="thumb"><img src="' + o.img + '" alt="" loading="lazy"></span>' : (o.em ? '<span class="em">' + o.em + '</span>' : '');
          html += '<div class="opt' + (ans[s.key] === o.v ? ' sel' : '') + '" data-v="' + o.v + '">' + icon
            + '<div><b>' + (o.label || o.v) + '</b>' + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</div><span class="chk"></span></div>';
        });
      }

      bodyEl.innerHTML = html;
      nextBtn.style.display = showNext ? '' : 'none';
      nextBtn.disabled = nextDisabled;
      nextBtn.textContent = 'Continue →';
      bindOpts(s);
    }

    function bindOpts(s) {
      bodyEl.querySelectorAll('.opt').forEach(function (el) {
        el.onclick = function () {
          if (el.hasAttribute('data-m')) {
            var k = el.getAttribute('data-m');
            ans.mealParts[k] = !ans.mealParts[k];
            ans.meals = mealLabel(ans.mealParts);
            render();
            return;
          }
          var v = el.getAttribute('data-v');
          if (!v) return;
          if (s.type === 'allergy') {
            if (v === 'Yes') { ans.hasAllergies = true; render(); }
            else { ans.hasAllergies = false; ans.allergies = []; ans.intolerances = []; step++; render(); }
          } else {
            ans[s.key] = v;
            // switching diet changes which prepaid product we're buying, and
            // clears any allergy picks that don't exist on the new diet
            if (s.key === 'diet') {
              loadDiet(v);
              var R = DIET_RESTRICTIONS[v] || { allergies: [], intolerances: [] };
              ans.allergies = ans.allergies.filter(function (a) { return R.allergies.indexOf(a) > -1; });
              ans.intolerances = ans.intolerances.filter(function (a) { return R.intolerances.indexOf(a) > -1; });
            }
            step++;
            render();
          }
        };
      });
      bodyEl.querySelectorAll('.tag').forEach(function (el) {
        el.onclick = function () {
          var a = el.getAttribute('data-a'), g = el.getAttribute('data-g');
          var arr = g === 'i' ? ans.intolerances : ans.allergies;
          var i = arr.indexOf(a);
          if (i > -1) { arr.splice(i, 1); } else { if (arr.length >= MAX_PICK) return; arr.push(a); }
          render();
        };
      });
    }

    nextBtn.onclick = function () {
      var s = STEPS[step];
      if (s && s.type === 'meals') ans.meals = mealLabel(ans.mealParts);
      step++;
      render();
    };
    backBtn.onclick = function () { if (step > 0) { step--; render(); } };

    function renderSummary() {
      titleEl.textContent = 'Your 4-week plan';
      stepNoEl.textContent = 'Almost done';
      chipEl.textContent = ans.diet + ' · 4-week prepaid';
      barEl.style.width = '100%';
      backBtn.style.visibility = 'visible';
      nextBtn.style.display = 'none';
      if (gkTrust) gkTrust.style.display = 'none';
      bodyEl.innerHTML = '<div class="muted">Matching your plan…</div>';

      var d = DIET[ans.diet];
      Promise.resolve(CACHE[d.prepaid] || fetch('/products/' + d.prepaid + '.js').then(function (r) { return r.json(); }))
        .then(function (p) { CACHE[d.prepaid] = p; paint(false); })
        .catch(function () { paint(true); });

      function paint(offline) {
        var q = offline ? null : quote(ans.meals, ans.size);
        var allergyTxt = ans.allergies.length ? ans.allergies.join(', ') : 'None';
        var intolTxt = ans.intolerances.length ? ans.intolerances.join(', ') : 'None';
        var dlv = deliveryInfo(ans.deliveryTime);
        var props = {
          'First Delivery Date': dlv.date,
          'First Delivery Day': dlv.day,
          'Delivery Time': dlv.time,
          'Allergy': allergyTxt,
          'Intolerances': intolTxt
        };

        var html = '';
        html += '<div class="sum-row"><span>Plan</span><b>' + ans.diet + ' · 4-week prepaid</b></div>';
        html += '<div class="sum-row"><span>Schedule</span><b>5-day (Mon–Fri) · ' + ans.meals + '</b></div>';
        html += '<div class="sum-row"><span>Size</span><b>' + ans.size + '</b></div>';
        if (q) html += '<div class="sum-row"><span>Total meals</span><b>' + q.meals + ' meals</b></div>';
        html += '<div class="sum-row"><span>First delivery</span><b>' + dlv.day + ', ' + dlv.date + '</b></div>';
        html += '<div class="sum-row"><span>Delivery time</span><b>' + dlv.time + '</b></div>';
        html += '<div class="sum-row"><span>Deliveries</span><b>3 drops a week · 4 weeks</b></div>';
        html += '<div class="sum-row"><span>Allergies</span><b>' + allergyTxt + '</b></div>';
        html += '<div class="sum-row"><span>Intolerances</span><b>' + intolTxt + '</b></div>';

        if (q) {
          html += '<div style="text-align:center;margin:14px 0 2px">'
            + '<div style="font-family:var(--serif);font-size:27px;color:var(--green)">' + money(q.total) + '</div>'
            + '<div style="color:var(--muted);font-size:13px">' + money(q.perMeal) + ' / meal · ' + q.meals + ' meals · charged every 28 days</div>'
            + '</div>';
          if (q.save) {
            // Compared against the weekly ONE-TIME list price x 4 (the "standard"
            // price). The weekly plan also has a 10% Subscribe & Save, so the
            // like-for-like gap vs a weekly subscriber is smaller (~6%).
            html += '<div class="savebar">Save ' + money(q.save) + ' (' + q.savePct + '%) vs the standard weekly price</div>';
          }
          html += '<div style="text-align:center"><span class="pill">Free island-wide delivery · pause or cancel anytime</span></div>';
        } else if (offline) {
          html += '<div style="text-align:center;margin:20px 0"><div class="pill">Could not load live price — please try again</div></div>';
        } else {
          html += '<div style="margin:18px 0;color:#b04a2a">That combination isn’t available on the 4-week plan.</div>';
        }

        html += '<button class="btn" id="gkFinish" style="width:100%;margin-top:14px"' + (q ? '' : ' disabled') + '>Get my plan — review my order</button>';
        bodyEl.innerHTML = html;

        var fb = bodyEl.querySelector('#gkFinish');
        if (fb && q) {
          fb.onclick = function () {
            fb.disabled = true;
            fb.textContent = 'Adding…';
            var item = { id: q.variant.id, quantity: 1, properties: props };
            if (q.sellingPlan) item.selling_plan = q.sellingPlan;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [item] })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
              window.location.href = '/cart';
            }).catch(function () {
              fb.disabled = false;
              fb.textContent = 'Try again';
            });
          };
        }
      }
    }

    if (ans.diet) loadDiet(ans.diet);
    render();
  }

  if (new URLSearchParams(location.search).get('openQuiz') === 'true') {
    var dq = new URLSearchParams(location.search).get('diet') || undefined;
    window.addEventListener('load', function () { setTimeout(function () { window.openQuiz(dq); }, 300); });
  }
})();
